// src/json/servicesOverview.json
export const servicesOverviewCommercialInteriorPainting = {
    eyebrow: "OUR COMMERCIAL INTERIOR",
    titleHighlight: "PAINTING SERVICES INCLUDE:",
    items: [
        {
            title: "Office & Corporate Spaces",
            description: "Enhancing work environments with clean, modern, and professional finishes tailored to your brand and business identity."
        },
        {
            title: "Retail & Hospitality Painting",
            description: "Creating welcoming, high-end interiors for retail stores, restaurants, hotels, and entertainment venues."
        },
        {
            title: "Warehouses & Industrial Facilities",
            description: "Applying durable, scuff-resistant coatings designed to withstand high-traffic and industrial conditions."
        },
        {
            title: "Tenant Improvement & Repaints",
            description: "Refreshing interiors for new tenants, lease turnovers, and building upgrades with high-quality finishes."
        },
        {
            title: "Drywall Repair & Surface Preparation",
            description: "Smoothing imperfections with patching, priming, and sanding for a seamless, professional look."
        }
    ],
    imageUrl: "/assets/imgs/services/5CommercialInteriorPainting/servicesOverview/fondo.jpg",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  